export enum ErrorCode {
  CustomDomainError = 'CustomDomainError',
  Unknown = 'Unknown',
  Unpublish = '404001',
  Unauthorized = '401000',
  NotExisted = 'NotExisted',
  NetworkError = 'NetworkError',
  InvalidPath = 'InvalidPath',
}
